<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0001 23.0323L10.4668 26.3656C10.2223 26.5212 9.96676 26.5878 9.70009 26.5656C9.43343 26.5434 9.20009 26.4545 9.00009 26.299C8.80009 26.1434 8.64454 25.9492 8.53343 25.7163C8.42232 25.4825 8.40009 25.2212 8.46676 24.9323L9.93343 18.6323L5.03343 14.399C4.81121 14.199 4.67254 13.971 4.61743 13.715C4.56143 13.4598 4.57787 13.2101 4.66676 12.9656C4.75565 12.7212 4.88898 12.5212 5.06676 12.3656C5.24454 12.2101 5.48898 12.1101 5.80009 12.0656L12.2668 11.499L14.7668 5.56563C14.8779 5.29896 15.0503 5.09896 15.2841 4.96563C15.517 4.83229 15.7556 4.76562 16.0001 4.76562C16.2445 4.76562 16.4837 4.83229 16.7174 4.96563C16.9503 5.09896 17.1223 5.29896 17.2334 5.56563L19.7334 11.499L26.2001 12.0656C26.5112 12.1101 26.7557 12.2101 26.9334 12.3656C27.1112 12.5212 27.2445 12.7212 27.3334 12.9656C27.4223 13.2101 27.4392 13.4598 27.3841 13.715C27.3281 13.971 27.189 14.199 26.9668 14.399L22.0668 18.6323L23.5334 24.9323C23.6001 25.2212 23.5779 25.4825 23.4668 25.7163C23.3556 25.9492 23.2001 26.1434 23.0001 26.299C22.8001 26.4545 22.5668 26.5434 22.3001 26.5656C22.0334 26.5878 21.7779 26.5212 21.5334 26.3656L16.0001 23.0323Z"
      :fill="isFilled ? '#FFED00' : '#D6D6D6'"
    />
  </svg>
</template>

<script>
export default {
  name: "IconBigStar",

  props: {
    isFilled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
